import { imageLoader } from "@/lib/sanity/client";
import ImageComponent from "next/image";
import React, { forwardRef, useState } from "react";
import { Container } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Image = ImageComponent as any;

type Props = {
  image?: any;
};

const Illustration = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { image } = props;
  const [loaded, setLoaded] = useState<boolean>(false);

  return (
    <Container ref={ref} $hasLoaded={loaded}>
      {image?.asset?.url && (
        <Image
          src={image.asset.url}
          layout="fill"
          objectFit="contain"
          alt={image.alt || ""}
          loader={imageLoader}
          onLoadingComplete={() => setLoaded(true)}
          priority
        />
      )}
    </Container>
  );
});

Illustration.displayName = "Illustration";

export default Illustration;
